
<div class="flow-container">
  <!-- Alert for declined/messages -->
  @if (showAlert) {
    <div class="alert alert-warning">
      {{ alertMessage }}
    </div>
  }

  <!-- Progress indicator -->
  <div class="progress-container">
    <div class="progress-bar">
      <div 
        class="progress-fill"
        [style.width]="(currentSectionIndex / (sections.length - 1)) * 100 + '%'"
      ></div>
    </div>
    
  </div>

  <!-- Sections -->
 @for (section of sections; track section.id) {
  @if (section.visible) {
    <div class="section-card">
      <h2>{{ section.title }}</h2>
      <p [innerHTML]="section.description"></p>
      
      <!-- Content for non-final sections -->
      @if (!isFinalSection()) {
        <div class="checkbox-container">
          <label class="checkbox-label">
            <input 
              type="checkbox" 
              [checked]="section.checked"
              (change)="onCheckboxChange(section, $event)"
              [disabled]="section.completed"
            >
            <span class="checkmark"></span>
            {{ section.consentDescription }}
          </label> 
        </div>
      }  

      <!-- Navigation Buttons -->
      <div class="button-container">
        <!-- Previous Button -->
        @if (currentSectionIndex > 0) {
          <button 
            type="button" 
            class="btn btn-outline"
            (click)="goToPreviousSection()"
          >
            ← Previous
          </button>
        }

        <div class="action-buttons"> 
          @if (!isFinalSection()) {
            <button 
              type="button" 
              class="btn btn-primary"
              [disabled]="!section.checked"
              (click)="confirmSection()"
            >
              Confirm & Continue →
            </button>

            <button 
              type="button" 
              class="btn btn-secondary"
              (click)="declineSection(section)"
            >
              Decline
            </button>
          } @else {
            <button 
              type="button" 
              class="btn btn-success"
              [disabled]="isSubmitting"
              (click)="finalSubmit()"
            >
              @if (isSubmitting) {
                <span class="spinner"></span>
              }
              {{ isSubmitting ? 'Submitting...' : 'Complete' }}
            </button>
          }
        </div>
      </div>
    </div>
  }
}
   
</div>